export default __webpack_public_path__ + "static/sa-b9a346574cdc8950dd34b50780441f57.svg";